export const NOTICE_CHANGED = 'rv-system-notices-changed';
export const NOTICE_STORAGE_KEY = 'rv-system-notices-refresh';

export function notifySystemNoticesChanged() {
  window.dispatchEvent(new Event(NOTICE_CHANGED));
  try { localStorage.setItem(NOTICE_STORAGE_KEY, `${Date.now()}-${Math.random()}`); } catch { /* Other devices still poll. */ }
}

export const noticeReadOptions = signal => ({ signal, timeout: 10000, params: { __notice_read: `${Date.now()}-${Math.random()}` }, headers: { 'Cache-Control': 'no-cache' } });
